import * as React from "react"
import { Typography, Button } from "@material-ui/core"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import { useStyles } from "./styles"

interface CaseStudyContentProps {
  content: Object[]
}

const CaseStudyContent = ({ content }: CaseStudyContentProps) => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <div className={classes.innerWrapper}>
          {content.map((item: any, index) => (
            <div
              key={`case-study-content-item-${index}`}
              className={classes.itemWrapper}
            >
              <Typography variant="subtitle2" className={classes.itemTitle}>
                {item.title}
              </Typography>
              {item.description &&
                item.description.map((dItem: any, dIndex: number) => (
                  <Typography
                    key={`case-study-description-item-${dIndex}`}
                    variant="body2"
                    className={classes.paragraph}
                  >
                    {dItem}
                  </Typography>
                ))}
              <ul>
                {item.list &&
                  item.list.map((lItem: string, lIndex: number) => (
                    <li
                      key={`case-study-content-item-list-${lIndex}`}
                      className={classes.listItem}
                    >
                      <Typography variant="body2">{lItem}</Typography>
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className={classes.footerButton}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          href={"/client-work"}
          className={classes.button}
          endIcon={<ArrowForwardIosIcon />}
        >
          View All Case Studies
        </Button>
      </div>
    </>
  )
}

export default CaseStudyContent
